export const NEWS_PER_PAGE = 20;